<template>
  <div id="view-empleado">
    <h3>Detalle de empleado :{{nombre}}</h3>
    <ul class="collection with-header">
      <li class="collection-header">
        <h4>{{nombre}}</h4>
      </li>
      <li class="collection-item">ID del empleado : {{empleado_id}}</li>
      <li class="collection-item">Area: {{area}}</li>
      <li class="collection-item">Posicion: {{posicion}}</li>
    </ul>
    <router-link to="/" class="btn grey">Regresar</router-link>
    <button class="btn red" @click="quitarEmpleado">Quitar empleado</button>

    <div class="fixed-action-btn">
      <router-link v-bind:to="{name: 'edit-empleado', params: {empleado_id:empleado_id}}" class="btn-floating btn-large red">
        <i class="fa fa-pencil-alt"></i>
      </router-link>
    </div>
  </div>
</template>
<script>
import db from "./firebaseInit";
export default {
  name: "view-empleado",
  data() {
    return {
      empleado_id: null,
      nombre: null,
      area: null,
      posicion: null
    };
  },
  beforeRouteEnter(to, from, next) {
    // ...
    db.collection("empleados")
      .where("empleado_id", "==", to.params.empleado_id)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          next(vm => {
            vm.empleado_id = doc.data().empleado_id;
            vm.nombre = doc.data().nombre;
            vm.area = doc.data().area;
            vm.posicion = doc.data().posicion;
          });
        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      db.collection("empleados")
        .where("empleado_id", "==", this.$route.params.empleado_id)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.empleado_id = doc.data().empleado_id;
            (this.nombre = doc.data().nombre), (this.area = doc.data().area);
            this.posicion = doc.data().posicion;
          });
        });
    },
    quitarEmpleado() {
      if (confirm("¿Estas seguro de eliminarlo?")) {
        db.collection("empleados")
          .where("empleado_id", "==", this.$route.params.empleado_id)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              doc.ref.delete();
              //para redirigir se usa router
              this.$router.push('/')
            });
          });
      }
    }
  }
};
</script>